import React, { Suspense, useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import block from 'bem-cn'
import { AnimatePresence, motion } from 'framer-motion'

import { useMediaDevice } from '@bcraft-frontend-lib/core'

import { useFrameManager } from '@bcraft-frontend-lib/slots'
import { changeOpenedLeftSidePanel, changeOpenedRightSidePanel } from 'features/sidePanel/actions'

import BonusPromotionNotification from 'components/BonusPromotionNotification/BonusPromotionNotification'
import { DefineDeviceComponent } from 'components/DefineDeviceComponent'
import { Footer } from 'components/Footer/Footer'
import { Header } from 'components/Header/Header'
import { DeviceDetect } from 'components/helpers/DeviceDetect/DeviceDetect'
import CashbackNotify from 'components/notifies/CashbackNotify/CashbackNotify'
import FirstDepositNotify from 'components/notifies/FirstDepositNotify/FirstDepositNotify'
import PersonalJackpotNotify from 'components/notifies/PersonalJackpotNotify/PersonalJackpotNotify'
import PageLoading from 'components/PageLoading/PageLoading'
import { AppGlobalPolling } from 'components/pollings/AppGlobalPolling'
import { SideMenu } from 'components/SideMenu/SideMenu'
import { SideMenuLeftContent } from 'components/SideMenu/SideMenuLeftContent'
import { SideMenuRightContent } from 'components/SideMenu/SideMenuRightContent'

import { getCurrenciesList } from './features/settings/actions'

import './App.scss'

const b = block('app')

const App: React.FC = ({ children }) => {
  // useLiveChat()

  const dispatch = useDispatch()

  const { count: framesCount } = useFrameManager()
  const isFrameOpen = framesCount > 0

  const isMobileOrTablet = useMediaDevice({ query: 'maxLaptop' })

  const [isScrolled, setIsScrolled] = useState<boolean>(true)

  const [isOpenLeftSideMenu, setIsOpenLeftSideMenu] = useState(false)
  const [isOpenRightSideMenu, setIsOpenRightSideMenu] = useState(false)

  const mobileMenuRef = useRef<HTMLDivElement>(null)
  const appContainerRef = useRef<HTMLDivElement>(null)

  const setLeftSideMenu = useCallback((val?: boolean) => {
    if (typeof val === 'boolean') setIsOpenLeftSideMenu(val)
    else setIsOpenLeftSideMenu(prev => !prev)
  }, [])
  const setRightSideMenu = useCallback((val?: boolean) => {
    if (typeof val === 'boolean') setIsOpenRightSideMenu(val)
    else setIsOpenRightSideMenu(prev => !prev)
  }, [])

  useEffect(() => {
    const scrollContainer = appContainerRef?.current
    const mobileMenu = mobileMenuRef?.current

    const scrollHandler = () => {
      if (scrollContainer?.scrollTop === 0 && !mobileMenu?.classList.contains('mobile_top')) {
        setIsScrolled(true)
      } else if (scrollContainer?.scrollTop !== 0 && mobileMenu?.classList.contains('mobile_top')) {
        setIsScrolled(false)
      }
    }
    scrollContainer?.addEventListener('scroll', scrollHandler, { capture: true })

    return () => {
      scrollContainer?.removeEventListener('scroll', scrollHandler, { capture: true })
    }
  }, [])

  useLayoutEffect(() => {
    setTimeout(() => localStorage.removeItem('reloadCount'), 2000)
  }, [])

  useEffect(() => {
    if (!isMobileOrTablet) {
      dispatch(changeOpenedLeftSidePanel(false))
      dispatch(changeOpenedRightSidePanel(false))
    }
  }, [isMobileOrTablet, dispatch])

  useEffect(() => {
    dispatch(getCurrenciesList())
  }, [])

  return (
    <div className={b()}>
      <CashbackNotify />
      <FirstDepositNotify />
      <PersonalJackpotNotify />
      <BonusPromotionNotification />
      <AppGlobalPolling />
      <div className={b('container')} ref={appContainerRef} id="app-container-id">
        <DeviceDetect />

        <DefineDeviceComponent
          mobileComponent={
            <>
              <SideMenu position="left" isOpen={isOpenLeftSideMenu} onToggleSideMenu={setLeftSideMenu}>
                <SideMenuLeftContent onClose={() => setLeftSideMenu(false)} />
              </SideMenu>
              <SideMenu position="right" isOpen={isOpenRightSideMenu} onToggleSideMenu={setRightSideMenu}>
                <SideMenuRightContent onClose={() => setRightSideMenu(false)} />
              </SideMenu>
            </>
          }
          desktopComponent={<></>}
        />

        <motion.div
          className={b('main-wrapper')}
          initial={{ x: 0 }}
          // animate={returnAnimation}
          transition={{ duration: 0.35 }}>
          {!isFrameOpen && <Header onToggleLeftMenu={setLeftSideMenu} onToggleRightMenu={setRightSideMenu} />}

          <div className={b('main')}>
            <div className={b('main-inner', { isFrameOpen })}>
              {/* <Support /> */}

              <Suspense fallback={<PageLoading isLoading />}>
                <div className={b('main-content')}>
                  <AnimatePresence exitBeforeEnter>{children}</AnimatePresence>
                </div>
              </Suspense>
              {/* <ScrollToTop /> */}
              <Footer scrollRef={appContainerRef} />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default App
